<div class="field" soho-busyindicator [text]="' '" [transparentOverlay]="true" [overlayOnly]="true" [timeToComplete]="500">
  <label
      *ngIf="label"
      soho-label
      [required]="isRequired"
      [attr.for]="id"
      [personalize]="personalize"
      lm-label
        [layoutField] = "field"
        [layoutInfo]="layoutInfo"
        [personalize]="personalize"
      lm-text-style [textStyle]="label?.textStyle"
  >{{triggerValue| formatLabelRule:field:labelResourceValue:model:specFields}}</label>

  <ng-container [ngSwitch]="displayType">
    <ng-container *ngSwitchCase="layoutDisplayType.PLAIN_LINK">
      <a *ngIf="valid; else NotValid" soho-hyperlink="{{hyperlinkType}}"
          [attr.tabindex]="0"
          [ngClass]="{'lm-hyperlink': !layoutObject.icon, 'lm-form-icon-button': layoutObject.icon && !layoutObject.title}"
          [attr.id]="id"
          [class.personalize-actionable]="personalize"
          (click)="onClickEvent($event)"
          (keydown.enter)="onClickEvent($event)"
          (focusout)="onFieldBlur($event)"
          soho-alert
      >
        <!-- display link as text if there is no icon -->
        <ng-container *ngIf="!layoutObject.icon">
          <span
            attr.aria-label="{{triggerValue | formatLabelRule:field:labelResourceValue:model:specFields}} - {{triggerValue | formatMessageRule:true:textMessageRule:model:specFields}}"
          >{{triggerValue | formatMessageRule:true:textMessageRule:model:specFields}}</span>
        </ng-container>

        <!-- display as icon if there is icon, use soho icon if icon name matches soho icon name -->
        <ng-container *ngIf="layoutObject.icon && !validSohoIcon  && !layoutObject.title">
          <img class="icon" src="{{layoutObject.iconUrl}}" alt=""/>
          {{triggerValue | formatMessageRule:true:textMessageRule:model:specFields}}
        </ng-container>
        <ng-container *ngIf="layoutObject.icon && validSohoIcon">
          <svg class="icon" focusable="false" aria-hidden="true" role="presentation">
            <use [attr.xlink:href]="'#icon-' +  layoutObject.icon + ''"></use>
          </svg>
          {{triggerValue | formatMessageRule:true:textMessageRule:model:specFields}}
        </ng-container>
        <ng-container *ngIf="layoutObject.icon && !validSohoIcon && layoutObject.title">
          <!-- decorative image, alt can be left blank since there's an adjacent info -->
          <img class="icon" src="{{layoutObject.iconUrl}}" alt=""/>
          {{triggerValue | formatMessageRule:true:textMessageRule:model:specFields}}
        </ng-container>
      </a>
      <ng-template #NotValid>
        <p
            attr.id="{{id}}"
            [class.lm-text-data]="true"
            [class.hide-white-space]="true"
            [class.personalize-actionable]="personalize"
            [class.data]="true"
        >{{triggerValue | formatMessageRule:true:textMessageRule:model:specFields}}</p>
      </ng-template>
    </ng-container>

    <ng-container *ngSwitchCase="layoutDisplayType.MAIL_LINK">
      <a href="{{triggerValue | formatMessageRule:true:layoutObject.httpUrl:model:specFields}}"
          soho-hyperlink="{{hyperlinkType}}"
          [class.personalize-actionable]="personalize"
          attr.aria-label="{{triggerValue | formatLabelRule:field:labelResourceValue:model:specFields}} - {{triggerValue | formatMessageRule:true:textMessageRule:model:specFields}}"
          [attr.id]="id"
          [attr.tabindex]="0"
          soho-alert
          soho-tooltip [content]=""
          (mouseenter)="onMouseEnter()"
          (focusout)="onFieldBlur($event)"
      >{{triggerValue | formatMessageRule:true:textMessageRule:model:specFields}}</a>
    </ng-container>
  </ng-container>
</div>
